export default __webpack_public_path__ + "static/media/42_mobile.91d98e0e.jpg";